var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var TaskBoardFilterType;
(function (TaskBoardFilterType) {
    TaskBoardFilterType["invoiceStreamId"] = "invoiceStreamId";
    TaskBoardFilterType["relationId"] = "relationId";
    TaskBoardFilterType["relationName"] = "relationName";
    TaskBoardFilterType["taskId"] = "taskId";
    TaskBoardFilterType["taskTemplates"] = "taskTemplates";
    TaskBoardFilterType["subtaskId"] = "subtaskId";
    TaskBoardFilterType["userId"] = "userId";
    TaskBoardFilterType["relationUserId"] = "relationUserId";
    TaskBoardFilterType["status"] = "status";
    TaskBoardFilterType["subtaskStatus"] = "subtaskStatus";
    TaskBoardFilterType["kpi"] = "kpi";
    TaskBoardFilterType["deadlineFrom"] = "deadlineFrom";
    TaskBoardFilterType["deadlineUntil"] = "deadlineUntil";
    TaskBoardFilterType["executionDateFrom"] = "executionDateFrom";
    TaskBoardFilterType["executionDateUntil"] = "executionDateUntil";
    TaskBoardFilterType["sortByExecutionDate"] = "sortByExecutionDate";
    TaskBoardFilterType["plannedTaskId"] = "plannedTaskId";
    TaskBoardFilterType["periodicityId"] = "periodicityId";
    TaskBoardFilterType["ownCompanies"] = "ownCompanies";
    TaskBoardFilterType["legalEntities"] = "legalEntities";
    TaskBoardFilterType["relationTags"] = "relationTags";
    TaskBoardFilterType["withoutRelationTags"] = "withoutRelationTags";
    TaskBoardFilterType["assistant"] = "assistant";
    TaskBoardFilterType["responsible"] = "responsible";
    TaskBoardFilterType["associate"] = "associate";
    TaskBoardFilterType["assistantBackup"] = "assistantBackup";
    TaskBoardFilterType["billingUser"] = "billingUser";
    TaskBoardFilterType["seniorUser"] = "seniorUser";
    TaskBoardFilterType["assignmentTemplateId"] = "assignmentTemplateId";
    TaskBoardFilterType["endFiscalYears"] = "endFiscalYears";
    TaskBoardFilterType["accountingSoftware"] = "accountingSoftware";
    TaskBoardFilterType["receiveInvoiceSoftware"] = "receiveInvoiceSoftware";
    TaskBoardFilterType["otherSoftware"] = "otherSoftware";
    TaskBoardFilterType["sendInvoiceSoftware"] = "sendInvoiceSoftware";
    TaskBoardFilterType["relationTypes"] = "relationTypes";
    TaskBoardFilterType["crmTypes"] = "crmTypes";
    TaskBoardFilterType["onlySubtasksForAssignedUser"] = "onlySubtasksForAssignedUser";
    TaskBoardFilterType["teams"] = "teams";
    TaskBoardFilterType["vatPeriodicity"] = "vatPeriodicity";
    TaskBoardFilterType["financialStatementScheme"] = "financialStatementScheme";
    TaskBoardFilterType["socialSecurityFund"] = "socialSecurityFund";
    TaskBoardFilterType["socialSecretariat"] = "socialSecretariat";
    TaskBoardFilterType["createdBy"] = "createdBy";
    TaskBoardFilterType["legalForms"] = "legalForms";
    TaskBoardFilterType["withoutTags"] = "withoutTags";
    TaskBoardFilterType["withTags"] = "withTags";
    TaskBoardFilterType["userIsNextAssignedUser"] = "userIsNextAssignedUser";
    TaskBoardFilterType["includeDoneTasksInThePast"] = "includeDoneTasksInThePast";
    TaskBoardFilterType["relationGroups"] = "relationGroups";
    TaskBoardFilterType["year"] = "year";
    TaskBoardFilterType["mixedTaxPayer"] = "mixedTaxPayer";
    TaskBoardFilterType["mixedTaxPayerVatDeductionMethod"] = "mixedTaxPayerVatDeductionMethod";
    TaskBoardFilterType["selfBooker"] = "selfBooker";
    TaskBoardFilterType["relationHandlingLevels"] = "relationHandlingLevels";
})(TaskBoardFilterType || (TaskBoardFilterType = {}));
export var KPIOptions;
(function (KPIOptions) {
    KPIOptions["total"] = "total";
    KPIOptions["blocked"] = "blocked";
    KPIOptions["pastDeadline"] = "pastDeadline";
    KPIOptions["deadlineOneWeek"] = "deadlineOneWeek";
    KPIOptions["deadlineTwoWeeks"] = "deadlineTwoWeeks";
    KPIOptions["deadlineThreeWeeks"] = "deadlineThreeWeeks";
    KPIOptions["deadlineFourWeeks"] = "deadlineFourWeeks";
    KPIOptions["deadlineThreeMonths"] = "deadlineThreeMonths";
    KPIOptions["deadlineSixMonths"] = "deadlineSixMonths";
    KPIOptions["deadlineOneYear"] = "deadlineOneYear";
    KPIOptions["nextUserIsMe"] = "nextUserIsMe";
})(KPIOptions || (KPIOptions = {}));
export var MyTasksWidgetKPIOptions;
(function (MyTasksWidgetKPIOptions) {
    MyTasksWidgetKPIOptions["nextUserIsMe"] = "nextUserIsMe";
    MyTasksWidgetKPIOptions["pastDeadline"] = "pastDeadline";
    MyTasksWidgetKPIOptions["deadlineOneWeek"] = "deadlineOneWeek";
    MyTasksWidgetKPIOptions["deadlineTwoWeeks"] = "deadlineTwoWeeks";
    MyTasksWidgetKPIOptions["deadlineThreeWeeks"] = "deadlineThreeWeeks";
    MyTasksWidgetKPIOptions["deadlineFourWeeks"] = "deadlineFourWeeks";
    MyTasksWidgetKPIOptions["deadlineThreeMonths"] = "deadlineThreeMonths";
    MyTasksWidgetKPIOptions["deadlineSixMonths"] = "deadlineSixMonths";
    MyTasksWidgetKPIOptions["deadlineOneYear"] = "deadlineOneYear";
    MyTasksWidgetKPIOptions["executionDateBeforeThisWeek"] = "executionDateBeforeThisWeek";
    MyTasksWidgetKPIOptions["executionDateThisWeek"] = "executionDateThisWeek";
    MyTasksWidgetKPIOptions["executionDateNextWeek"] = "executionDateNextWeek";
    MyTasksWidgetKPIOptions["executionDateInTwoWeeks"] = "executionDateInTwoWeeks";
    MyTasksWidgetKPIOptions["executionDateInThreeWeeks"] = "executionDateInThreeWeeks";
})(MyTasksWidgetKPIOptions || (MyTasksWidgetKPIOptions = {}));
export var migrateTaskboardFilters = function (filters) {
    var result = __assign({}, filters);
    if (result.taskId) {
        result.taskTemplates = [result.taskId];
        result.taskId = null;
    }
    return result;
};
